import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { george, theme, pr } from "aaa";
import { ui } from "components/util/uiHelpers";
import { pushRoute } from "stores/RouterFunctions";
import { CreditCardUpgradeRoutes } from "./CreditCardUpgradeRoutes";
import { CreditCardUpgradeStore } from "./CreditCardUpgradeStore";
import { observer } from "mobx-react";
import { FormattedHTMLMessage } from "i18n/util";
import { amountToCurrencyString } from "types/amount";
import trackingStore from "stores/TrackingStore";

const labelStyle: React.CSSProperties = { wordBreak: "normal" };

export const CreditCardUpgradeSummary = observer(({ store }: { store: CreditCardUpgradeStore }) => {
    const [approvalChecked, setApprovalChecked] = React.useState(false);

    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;

    const buttonDisabled = !approvalChecked;

    const handleSubmit = async () => {
        try {
            await store.postUpgrade();
            await trackingStore.trackEvent({ eventName: "upgradeInitiated" });
            pushRoute(CreditCardUpgradeRoutes.SIGNING);
        } catch (error) {
            pushRoute("/error");
        }
    };

    return (
        <george.Background>
            <PageComponent>
                <george.Card style={{ marginBottom: theme.MARGIN_SMALL }}>
                    <div style={{ padding: theme.MARGIN }}>
                        <george.SectionTitle style={{ marginTop: 0 }}>
                            {ui.__("common.summary")}
                        </george.SectionTitle>
                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                        <george.ResponsiveSummaryElement label={ui.__("signing.action.label")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {ui.__("creditCardUpgrade.summary.action.description", { productName: store.upgradeDetails?.offer?.product })}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                        <george.ResponsiveSummaryElement label={ui.__("creditCardUpgrade.summary.closedCard")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {store.upgradeDetails?.card?.product}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                        <george.ResponsiveSummaryElement label={ui.__("creditCardUpgrade.summary.availabilityNewCard")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {ui.__("creditCardUpgrade.summary.availabilityNewCard.description")}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                        <george.ResponsiveSummaryElement label={ui.__("creditCardUpgrade.summary.limit")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {ui.__("creditCardUpgrade.summary.limit.description", { limit: amountToCurrencyString(store.upgradeDetails?.card?.limit) })}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                        <george.ResponsiveSummaryElement label={ui.__("creditCardUpgrade.summary.availableAmount")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {ui.__("creditCardUpgrade.summary.availableAmount.description")}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                        <george.ResponsiveSummaryElement label={ui.__("common.monthlyCosts")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {ui.__(
                                    "creditCardUpgrade.summary.feesFirstYear.decription",
                                    {
                                        oldAmount: amountToCurrencyString(store.upgradeDetails?.card?.fee),
                                        newAmount: amountToCurrencyString(store.upgradeDetails?.offer?.feeFirstYear)
                                    }
                                )}
                            </pr.SigningLabel>
                            <pr.SigningLabel>
                                {ui.__(
                                    "creditCardUpgrade.summary.fees.decription",
                                    {
                                        oldAmount: amountToCurrencyString(store.upgradeDetails?.card?.fee),
                                        newAmount: amountToCurrencyString(store.upgradeDetails?.offer?.fee)
                                    }
                                )}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                    </div>
                    <pr.LightSeparatorLine spacing={theme.MARGIN} />
                    <div style={{ padding: theme.MARGIN }}>
                        <george.ApprovalEmbedded
                            message={<FormattedHTMLMessage id="creditCardUpgrade.summary.approval" values={{ productName: store.upgradeDetails?.offer?.product }} />}
                            onCheck={(event, checked) => setApprovalChecked(checked)}
                        />
                    </div>
                    {!externalInterfaceStore.isGeorgeApp &&
                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                    }
                    <george.ActionButton
                        messageId="loan.summary.actionSign"
                        disableButton={buttonDisabled}
                        onClick={handleSubmit}
                        isLoading={store.isLoading}
                        primary
                        {...george.getActionButtonWebVersionProps()}
                    />
                </george.Card>
            </PageComponent>
        </george.Background>
    );
});


// WEBPACK FOOTER //
// ./src/components/creditCardUpgrade/CreditCardUpgradeSummary.tsx